module.exports = __webpack_public_path__ + "static/media/fees_enabled.5b301192.svg";